package  poscope.wire;
import tink.template.Html;
import poscope.views.Layout;
import poscope.wire.ILayout;
using poscope.wire.Log;
using Lambda;
class Actor{

    public static var actions:Map<String,Any>=new Map();
    private static var actionString=""; 
    public static  var scripts:Array<String>=[];
    public static var styles:Array<String>=[];

    @:isVar public static var defaultLayout(default,set):ILayout;
    @:isVar public static var defaultHead(default,set):IHead;

    @:isVar public static var head(default,set):IHead;

    public function new(){

    }
     static function set_defaultLayout(layout:ILayout){
        return defaultLayout=layout;
    }

   
    
     static function set_defaultHead(_head:IHead){
        head=_head;
        return defaultHead=_head;
    }

    static function set_head(_head:IHead){
        return head=_head;
    }


    public function getAction(){

    }
    public static function addAction<T>(layout:ILayout,a:ActionCommand,?data:T):ILayout{
       
            writeAction(a,data);
            addAct(layout,haxe.Serializer.run(actions));
            //addAct(layout,haxe.Json.stringify(actions));
            return layout;
       
    }

    private static  function addAct(layout:ILayout,actions:String):ILayout{
        actionString=actions;
        update(layout);
        return layout;
    }

    //just for naming ..
    public static function clean(layout:ILayout):ILayout{
        
        return cleanAfter(layout,true);
    }

    public static function cleanAfter(layout:ILayout,?_update:Bool=false):ILayout{
        
        clearScripts(layout,false);
        clearStyles(layout,false);
        head=defaultHead;
        actions.clear();
        actionString="";
        if( _update)update(layout);
        return layout;
    }

    public static function clearStyles(layout:ILayout,?_update:Bool=true):ILayout{
        
        while(styles.length>0)
            styles.pop();
        if( _update)
        update(layout);
        return layout;
    }
    
    public static function clearScripts(layout:ILayout,?_update:Bool=true):ILayout{
        
        while(scripts.length>0)
            scripts.pop();
        if( _update)
        update(layout);
        return layout;
    }
    public static function removeScript(layout:ILayout,script:String):ILayout{
        if (scripts.has(script)){
            scripts.remove(script);
            update(layout);
        }
        return layout;
    }
    public static function addScript(layout:ILayout,script:String):ILayout{
       
        if (!scripts.has(script)){
            scripts.push(script);
            update(layout);
        }
            return layout;

    }
     public static function addStyle(layout:ILayout,style:String):ILayout{
       
        if (!styles.has(style)){
            styles.push(style);
            update(layout);
        }
            return layout;

    }
    
    public dynamic static function update(layout:ILayout){
        //layout.head=poscope.views.Head.render(scripts,styles,actions);
       layout.head=head.render(scripts,styles,actionString);
    }

    static function  writeAction<T>(a:ActionCommand,?data:T){
        actions.set(a,data);
        return actions;
    }

    public static function withLayout(v:tink.template.Html,?layout:ILayout,?contentid="layout"):ILayout{
       var  _Layout=(layout==null)? defaultLayout : layout;
        update(_Layout);
        _Layout.viewContent=v;
        _Layout.id=contentid;
        return _Layout;
    }




}


//// good idee    bad impl
abstract HtmlPart(String) from String to String{
    public function new (p:String){
        this=p;
    }
    @:to public function toHtml():Html{
       return new Html(this);
    }
}

